import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      device: 'desktop',
      ua: '',
      users: {/* [id: string]: User */},
      pollGames: {},
      conversations: {},
      communities: {},
      communityPosts: {},
      posts: {},
      questions: {/* [id: string]: question */},
      quizzes: {},
      rooms:{},
      chat: {
        // code:'123',
        // msg:'ftest'
      },
      answered: false, // indicate if the question/poll is answered,
      quiz:{}
    },
    actions,
    mutations,
    getters
  })
}



// WEBPACK FOOTER //
// src/store/index.js